import api from '@/lib/api';
import { generateFields } from '@/api/generators-api';
import type { FeeInfo } from '@/types/tournament.model';
import type {
  OrganizedMatch,
  OrganizedMatchEditPayload,
  OrganizedMatchPayload,
} from '@/types/organized-match.model';
import { ORGANIZED_MATCH_FIELDS } from './match-fields.config';

/** `from` and `to` are "yyyy-MM-dd"; `to` is inclusive (max range 31 days). */
export const getOrganizedMatches = async (
  clubId: string,
  from: string,
  to: string,
): Promise<OrganizedMatch[]> => {
  const response = await api.get<OrganizedMatch[]>('/matches/organized', {
    params: {
      clubId,
      from,
      to,
      fields: generateFields(ORGANIZED_MATCH_FIELDS),
    },
  });
  return response.data;
};

/** Only the id comes back (`fields`): response dates are UTC, so the grid is refetched instead of reading them. */
export const createOrganizedMatch = async (
  payload: OrganizedMatchPayload,
): Promise<OrganizedMatch> => {
  const response = await api.post<OrganizedMatch>('/matches', payload, {
    params: { fields: 'id' },
  });
  return response.data;
};

export const editOrganizedMatch = async (
  id: string,
  payload: OrganizedMatchEditPayload,
): Promise<OrganizedMatch> => {
  const response = await api.patch<OrganizedMatch>(`/matches/${id}`, payload, {
    params: { fields: 'id' },
  });
  return response.data;
};

export const deleteOrganizedMatch = async (id: string): Promise<void> => {
  await api.delete(`/matches/${id}`);
};

// Plain api.get: the createSingleApiWithFields helper would replace `params`
// when given a config. Not cached, the amount can change in AWS.
export const getOrganizedMatchFee = async (): Promise<number> => {
  const response = await api.get<FeeInfo>('/checkout/getmatch/fee', {
    params: { feeType: 'ORGANIZED_MATCH' },
  });
  return response.data.fee;
};
